import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CardProcessorOfferWrapper from "@components/layouts/cardProcessorOffersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function CardProcessingOffersHome(): ReactElement {
    return (
        <CardProcessorOfferWrapper>
            <PrivacyPolicy
                category="Card Processing Offers"
                domain="CardProcessingOffers.com"
            />
        </CardProcessorOfferWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
